// extracted by mini-css-extract-plugin
var _1 = "_goldTransactionDetails-module__button-container";
var _2 = "_goldTransactionDetails-module__container";
var _3 = "_goldTransactionDetails-module__details-table";
var _4 = "_goldTransactionDetails-module__product-container";
var _5 = "_goldTransactionDetails-module__show-serial-no";
export { _1 as "button-container", _2 as "container", _3 as "details-table", _4 as "product-container", _5 as "show-serial-no" }
